import React, { useCallback, useState } from 'react';

import { NewPersonForm } from '../';
import { ModalComponent } from '../../base2';
import { Button } from '../basic-inputs';

import { NoBeneficiariesDisplay } from './no-beneficiaries-display';
import { PersonMultiSelect } from './person-multi-select';
import { SelectedBeneficiary } from './selected-beneficiary';

import { ModalFormHeader } from '.';

interface BeneficiaryFormProps {
  beneficiaries?: any[];
  handleSelectBeneficiaries: (selected: any[]) => void;
  handleRemoveBeneficiary: (person: any) => void;
}

export function BeneficiaryForm({
  beneficiaries = [],
  handleSelectBeneficiaries,
  handleRemoveBeneficiary
}: BeneficiaryFormProps) {
  const [ showModal, setShowModal ] = useState(0);

  const handleShowModal = useCallback(() => {
    setShowModal(1);
  }, []);

  const handleClose = useCallback(() => {
    setShowModal(0);
  }, []);

  const handleShowAddPersonModal = useCallback(() => {
    setShowModal(2);
  }, []);

  const handleCancelNewPersonForm = useCallback(() => {
    setShowModal(1);
    const elements = document.getElementById('modal-content');
    Array.from(elements.children)
      .forEach(element => element.classList.remove('move-left'));
  }, []);

  const handleSaveCompletion = useCallback(() => {
    handleClose();
    handleCancelNewPersonForm();
  }, [ handleClose, handleCancelNewPersonForm ]);

  return (
    <div className="form-container beneficiary-form">
      <ModalFormHeader
        icon="group_add"
        header="Select Beneficiaries"
      />
      {
        beneficiaries.length === 0 ? (
          <NoBeneficiariesDisplay />
        ) : (
          beneficiaries.map((person) => (
            <SelectedBeneficiary
              key={person.id}
              person={person}
              handleRemoveBeneficiary={handleRemoveBeneficiary}
            />
          ))
        )
      }
      <Button fullWidth onClick={handleShowModal}>
        + Add Beneficiaries
      </Button>

      <ModalComponent 
        showModal={!!showModal} 
        closeModal={handleClose} 
        provideContainer={false}
      >
        <div id="modal-content" style={{ display: 'flex', width: '90%', overflowX: 'hidden', overflowY: 'auto', height: '70vh' }}>
          {
            showModal === 1 ? 
              <PersonMultiSelect
                handleSelectOptions={handleSelectBeneficiaries}
                selected={beneficiaries}
                multiple={true}
                handleClickableOption={handleShowAddPersonModal}
                handleCancel={handleClose}
                inModal={false}
              />
              :
              <NewPersonForm 
                handleCancel={handleCancelNewPersonForm}
                handleSaveCompletion={handleSaveCompletion}
                inModal={false}
              /> 
          }
        </div>
      </ModalComponent>
    </div>
  );
}
